import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { MdAnalytics } from "react-icons/md";
import { IoStatsChart } from "react-icons/io5";
import { BiSolidCategoryAlt } from "react-icons/bi";
import { TbTruckDelivery } from "react-icons/tb";
import { FaShop, FaSackDollar, FaCreditCard, FaNetworkWired, FaUsers, FaBoxesStacked } from "react-icons/fa6";
import { FaUserCircle, FaMoneyBill, FaEnvelope } from "react-icons/fa";
import { BsFileEarmarkRuledFill, BsQuestionCircleFill } from "react-icons/bs";
import { BiImageAdd } from "react-icons/bi";
import { MdOutlineChat, MdBlock } from "react-icons/md";
import { HiOutlineLogout, HiUsers } from "react-icons/hi";
import { LoginContext } from '../../Contexts/LoginContext';
import ChocowiLogo from "../../images/pngs/Logo.png"

function AdminHeader() {
    const { admin, adminLogout } = useContext(LoginContext);

    const hasAccess = (page) => {
        if (admin?.role === 'Super Admin') return true;
        if (admin?.role === 'Admin') return page !== 'Employees';
        if (admin?.role === 'Moderator') return admin?.access[page] !== undefined;
        return false;
    };

    const pages = [
        { path: 'dashboard', icon: <MdAnalytics className='icon' />, label: 'Dashboard' },
        { path: 'categories', icon: <BiSolidCategoryAlt className='icon' />, label: 'Categories' },
        { path: 'orders', icon: <TbTruckDelivery className='icon' />, label: 'Orders' },
        { path: 'sellers', icon: <FaShop className='icon' />, label: 'Sellers' },
        { path: 'buyers', icon: <FaUserCircle className='icon' />, label: 'Buyers' },
        { path: 'products-services', icon: <FaBoxesStacked className='icon' />, label: 'Listings' },
        { path: 'revenue', icon: <FaSackDollar className='icon' />, label: 'Revenue' },
        { path: 'analytics', icon: <IoStatsChart className='icon' />, label: 'Analytics' },
        { path: 'payments', icon: <FaCreditCard className='icon' />, label: 'Payments' },
        { path: 'social', icon: <FaNetworkWired className='icon' />, label: 'Social Links' },
        { path: 'fee', icon: <FaMoneyBill className='icon' />, label: 'Fee' },
        { path: 'blogs', icon: <FaMoneyBill className='icon' />, label: 'Blogs' },
        { path: 'banners', icon: <BiImageAdd className='icon' />, label: 'Banners' },
        { path: 'emails', icon: <FaEnvelope className='icon' />, label: 'Emails' },
        { path: 'faq', icon: <BsQuestionCircleFill className='icon' />, label: 'Information Centre' },
        { path: 'terms', icon: <BsFileEarmarkRuledFill className='icon' />, label: 'Terms & Conditions' },
        { path: 'restrictions', icon: <MdBlock className='icon' />, label: 'Restrictions' },
        { path: 'disputes', icon: <HiUsers className='icon' />, label: 'Disputes' },
        { path: 'chats', icon: <MdOutlineChat className='icon' />, label: 'Chats' },
        { path: 'employees', icon: <FaUsers className='icon' />, label: 'Employees' },
    ];

    return (
        <div className='adminHeaderDiv'>
            <section className="section">
                <div className="adminHeaderContent">

                    <div className="faithzyLogoDiv">
                        <img src={ChocowiLogo} alt="Chocowi Logo" className='faithzyLogo' />
                    </div>

                    <div className="horizontalLine"></div>

                    <ul className="mainMenu">
                        {pages.map((page, index) => (
                            hasAccess(page.label) && (
                                <li key={index}>
                                    <NavLink to={`/chwi-admin/${page.path}`} className={(v) => `${v.isActive ? "activeLi" : ""}`}>
                                        {page.icon}
                                        {page.label}
                                    </NavLink>
                                </li>
                            )
                        ))}
                        <li>
                            <NavLink className="adminLogoutBtn" onClick={adminLogout}><HiOutlineLogout /> Logout</NavLink>
                        </li>
                    </ul>

                </div>
            </section>
        </div>
    );
}

export default AdminHeader;